import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** ファイル種類 */
enum FileType {
  csv = 'CSV',
  pdf = 'PDF',
  csvForFileImport = 'CSV_FOR_FILE_IMPORT',
  log = 'LOG',
}
const nameConfig = {
  csv: new Map([[Locale.ja, 'CSV']]),
  pdf: new Map([[Locale.ja, 'PDF']]),
  csvForFileImport: new Map([[Locale.ja, 'CSV(データ取込用)']]),
  log: new Map([[Locale.ja, 'ログ']]),
};

const toEnum = rawValueToEnum(FileType, FileType.csv);
const toDisplay = enumToName(FileType, nameConfig);

export const fileType = {
  enum: FileType,
  nameConfig,
  toDisplay,
  toEnum,
};
export type { FileType };
